module.exports = __webpack_public_path__ + "img/200-baby.363af318.png";